import type { NotificationFilterValue } from '../../models/InAppNotification'

export type NotificationFilterOption = {
    value: NotificationFilterValue
    label: string
}

export const DEFAULT_NOTIFICATION_FILTER: NotificationFilterValue = 'unread'

const CARE_MANAGER_NOTIFICATION_FILTERS: NotificationFilterOption[] = [
    { value: 'unread', label: 'Unread' },
    { value: 'all', label: 'All' },
    { value: 'provideracceptance', label: 'Provider Acceptance' },
    { value: 'expiredreferrals', label: 'Expired Referrals' },
    { value: 'comments', label: 'Comments' }
]

const PROVIDER_NOTIFICATION_FILTERS: NotificationFilterOption[] = [
    { value: 'unread', label: 'Unread' },
    { value: 'all', label: 'All' },
    { value: 'newreferrals', label: 'New Referrals' },
    { value: 'commentresponses', label: 'Comment Responses' },
    { value: 'acceptedreferrals', label: 'Accepted Referrals' },
    { value: 'provideroptout', label: 'Provider Opt-Out' }
]

const DEFAULT_NOTIFICATION_FILTERS: NotificationFilterOption[] = [
    { value: 'unread', label: 'Unread' },
    { value: 'all', label: 'All' }
]

export const getNotificationFilters = (isProvider: boolean, isCareManager: boolean): NotificationFilterOption[] => {
    if (isProvider) return PROVIDER_NOTIFICATION_FILTERS
    if (isCareManager) return CARE_MANAGER_NOTIFICATION_FILTERS
    return DEFAULT_NOTIFICATION_FILTERS
}

export const hasFilterOption = (
    options: NotificationFilterOption[],
    filter: NotificationFilterValue
): boolean => options.some((option) => option.value === filter)